import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import './../css/App.css';

export default class NotFound extends Component {
  render() {
    return (
    	<div className="text-center">
      	<h1>Page Not Found</h1>
      	<Link to="/">to Home</Link>
      	</div>

    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/NotFound.js